var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { RMap } from "../collections";
import { automaticCrossSellingCategoryFilter, AutomaticCrossSellingListProvider, CrossSellingItemType, CrossSellingItemTypeId, Menu, ProductInstanceFactory, } from "../ordering";
import { AutomaticCrossSellingWeightsParser } from "../parsing";
import { LocalizationProvider } from "../locale";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
let AutomaticCrossSellingListProviderFactory = class AutomaticCrossSellingListProviderFactory {
    constructor(menu, automaticCrossSellingWeightsParser, localizationProvider, productInstanceFactory) {
        this.automaticCrossSellingWeightsParser = automaticCrossSellingWeightsParser;
        this.localizationProvider = localizationProvider;
        this.productInstanceFactory = productInstanceFactory;
        this.productTypes = menu.productTypes;
        this.productCategories = menu.productCategories;
        makeImmutable(this);
    }
    create(params) {
        const allowedProductCategories = this.productCategories.ids.filter((productCategoryId) => automaticCrossSellingCategoryFilter(this.localizationProvider.fallbackLocale, params.menuCatalogue.categories[productCategoryId.value].name));
        const productCategoryIds = RMap.fromIterable(this.productTypes.objects.map((productType) => [
            productType.id,
            productType.productCategoryId,
        ]));
        const candidateCrossSellingProductTypes = this.productTypes.filter((productType) => allowedProductCategories.includes(productType.productCategoryId));
        const candidateCrossSellingItemTypes = RMap.fromIterable(candidateCrossSellingProductTypes.objects.mapOptional((productType) => {
            const productInstance = this.productInstanceFactory.fromProductTypeIds([
                productType.id.value,
            ]);
            if (productInstance === null) {
                return null;
            }
            return [
                productType.id,
                new CrossSellingItemType({
                    id: new CrossSellingItemTypeId(productType.id.value),
                    productInstance,
                    kind: "Automatic",
                }),
            ];
        }));
        return new AutomaticCrossSellingListProvider({
            productCategoryIds,
            candidateCrossSellingItemTypes,
            weights: this.automaticCrossSellingWeightsParser.parse(params.weights),
        });
    }
};
AutomaticCrossSellingListProviderFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof Menu !== "undefined" && Menu) === "function" ? _a : Object, typeof (_b = typeof AutomaticCrossSellingWeightsParser !== "undefined" && AutomaticCrossSellingWeightsParser) === "function" ? _b : Object, typeof (_c = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _c : Object, typeof (_d = typeof ProductInstanceFactory !== "undefined" && ProductInstanceFactory) === "function" ? _d : Object])
], AutomaticCrossSellingListProviderFactory);
export { AutomaticCrossSellingListProviderFactory };
